import ServicePage from './ServicePage';

const SuiviPsychologique = () => <ServicePage serviceKey="therapy" />;

export default SuiviPsychologique;
